/**
 * FE-C2g batch-5: SA team provisioning — contract paths for sa-team.route.js.
 */

import { buildContractPath } from "./api/contract-client.js";

export const SA_CONSOLE_TIMEOUT_MS = 20000;

export function buildGetSaTeamPath() {
  return buildContractPath("get__sa_team");
}

export function buildPostSaTeamProvisionPath() {
  return buildContractPath("post__sa_team_provision");
}

/** @param {string} username */
export function buildPostSaTeamTtlPath(username) {
  return buildContractPath("post__sa_team_p_ttl", { pathParams: [username] });
}
